import React, { useEffect, useState } from "react";
import { Card } from "primereact/card";
import {
  getCashFlowReport,
  getFinanceDashboard,
  getProfitLossSummary,
  getTopExpensesSummary,
  getTopRevenuesSummary,
  getTurnoverAPARRatioSummary,
  getWorkingCapitalSummary,
} from "../../../../services/finance/financeReportService";
import { Chart } from "primereact/chart";
import { DialogActions, IconButton, Typography } from "@material-ui/core";
import { Search } from "@mui/icons-material";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import DialogLayout from "../../../../partials/content/DialogLayout";
import SearchFiscalYear from "../../setup/finance/searchFiscalYear";
import SearchFiscalPeriod from "../../setup/finance/searchFiscalPeriod";
import {
  abbrMonthName,
  abbrNum,
  formatPercent,
  ratioFormat,
} from "../../../../utils/utils";
import { Table } from "react-bootstrap";
import { DateTime } from "luxon";
function FinanceDashboard(props) {
  const {
    companyProfile,
    currentFiscalYear,
    currentFiscalPeriod,
    reload,
  } = useGlobalData();
  const [
    openSearchFiscalYearProfitLoss,
    setOpenSearchFiscalYearProfitLoss,
  ] = useState(false);
  const [
    openSearchFiscalYearCashFlow,
    setOpenSearchFiscalYearCashFlow,
  ] = useState(false);
  const [
    openSearchFiscalYearTurnoverAPARRatio,
    setOpenSearchFiscalYearTurnoverAPARRatio,
  ] = useState(false);
  const [
    openSearchFiscalYearWorkingCapital,
    setOpenSearchFiscalYearWorkingCapital,
  ] = useState(false);
  const [openSearchFiscalYear, setOpenSearchFiscalYear] = useState(false);
  const [
    openSearchFiscalPeriodTopRevenues,
    setOpenSearchFiscalPeriodTopRevenues,
  ] = useState(false);
  const [
    openSearchFiscalPeriodTopExpenses,
    setOpenSearchFiscalPeriodTopExpenses,
  ] = useState(false);
  const [openSearchFiscalPeriod, setOpenSearchFiscalPeriod] = useState(false);
  const [fiscalYearProfitLoss, setFiscalYearProfitLoss] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [fiscalYearCashFlow, setFiscalYearCashFlow] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [
    fiscalYearTurnoverAPARRatio,
    setFiscalYearTurnoverAPARRatio,
  ] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [fiscalYearWorkingCapital, setFiscalYearWorkingCapital] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [fiscalPeriodTopRevenues, setFiscalPeriodTopRevenues] = useState(
    currentFiscalPeriod.ID > 0
      ? currentFiscalPeriod
      : {
          ID: 0,
          fiscalYearID: 0,
          year: DateTime.now().year,
          month: DateTime.now().month,
          monthName: DateTime.now().toLocaleString({
            month: "short",
          }),
          statusID: 0,
        }
  );
  const [fiscalPeriodTopExpenses, setFiscalPeriodTopExpenses] = useState(
    currentFiscalPeriod.ID > 0
      ? currentFiscalPeriod
      : {
          ID: 0,
          fiscalYearID: 0,
          year: DateTime.now().year,
          month: DateTime.now().month,
          monthName: DateTime.now().toLocaleString({
            month: "short",
          }),
          statusID: 0,
        }
  );
  const [totalCashAmount, setTotalCashAmount] = useState(0);
  const [totalCashAmountPercent, setTotalCashAmountPercent] = useState(0);
  const [totalInventoryAmount, setTotalInventoryAmount] = useState(0);
  const [
    totalInventoryAmountPercent,
    setTotalInventoryAmountPercent,
  ] = useState(0);
  const [totalReceivablesAmount, setTotalReceivablesAmount] = useState(0);
  const [
    totalReceivablesAmountPercent,
    setTotalReceivablesAmountPercent,
  ] = useState(0);
  const [totalPayablesAmount, setTotalPayablesAmount] = useState(0);
  const [totalPayablesAmountPercent, setTotalPayablesAmountPercent] = useState(
    0
  );
  const [totalNetProfitThisMonth, setTotalNetProfitThisMonth] = useState(0);
  const [totalNetProfitLastMonth, setTotalNetProfitLastMonth] = useState(0);
  const [totalNetProfitPercent, setTotalNetProfitPercent] = useState(0);
  const [totalRevenuesThisMonth, setTotalRevenuesThisMonth] = useState(0);
  const [totalRevenuesLastMonth, setTotalRevenuesLastMonth] = useState(0);
  const [totalRevenuesPercent, setTotalRevenuesPercent] = useState(0);
  const [totalCOGSThisMonth, setTotalCOGSThisMonth] = useState(0);
  const [totalCOGSLastMonth, setTotalCOGSLastMonth] = useState(0);
  const [totalCOGSPercent, setTotalCOGSPercent] = useState(0);
  const [totalExpensesThisMonth, setTotalExpensesThisMonth] = useState(0);
  const [totalExpensesLastMonth, setTotalExpensesLastMonth] = useState(0);
  const [totalExpensesPercent, setTotalExpensesPercent] = useState(0);

  let fiscalYear = DateTime.now().year;
  let fiscalPeriod = DateTime.now().month;

  const [quickRatioData, setQuickRatioData] = useState({
    datasets: [],
    quickRatio: 0,
  });

  const [currentRatioData, setCurrentRatioData] = useState({
    datasets: [],
    currentRatio: 0,
  });

  const [debEquityRatio, setDebEquityRatio] = useState({
    datasets: [],
    debtEquityRatio: 0,
  });

  const [equityRatio, setEquityRatio] = useState({
    datasets: [],
    equityRatio: 0,
  });

  const [netProfitMargin, setNetProfitMargin] = useState({
    datasets: [],
    netProfitMargin: 0,
  });

  const [grossProfitMargin, setGrossProfitMargin] = useState({
    datasets: [],
    grossProfitMargin: 0,
  });

  const [receivablesInvoiceStatus, setReceivablesInvoiceStatus] = useState({
    datasets: [],
    receivablePaid: 0,
    receivableOutstanding: 0,
    receivableOverdue: 0,
  });

  const [payableInvoiceStatus, setPayablesInvoiceStatus] = useState({
    datasets: [],
    payablePaid: 0,
    payableOutstanding: 0,
    payableOverdue: 0,
  });
  const [receivablesAgingSummary, setReceivablesAgingSummary] = useState({
    datasets: [],
    receivableTotal: 0,
    receivableCurrent: 0,
    receivableThirtyDay: 0,
    receivableSixtyDay: 0,
    receivableNinetyDay: 0,
    receivableOverNinetyDay: 0,
  });
  const [payableAgingSummary, setPayableAgingSummary] = useState({
    datasets: [],
    payableTotal: 0,
    payableCurrent: 0,
    payableThirtyDay: 0,
    payableSixtyDay: 0,
    payableNinetyDay: 0,
    payableOverNinetyDay: 0,
  });

  const quickRatioSummaryData = {
    datasets: quickRatioData.datasets,
  };

  const quickRatioSummaryOptions = {
    aspectRatio: 2,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        yAlign: "bottom",
        displayColors: false,
        callbacks: {
          label: function(tooltipItem, data, value) {
            if (tooltipItem.dataset.needleValue < 0.6) {
              return `In Good condition`;
            } else if (
              tooltipItem.dataset.needleValue >= 0.6 &&
              tooltipItem.dataset.needleValue < 1
            ) {
              return `In Worrying condition`;
            } else if (tooltipItem.dataset.needleValue >= 1) {
              return `In Bad condition`;
            }
          },
        },
      },
    },
  };

  const quickRatioSummaryPlugins = {
    id: "quickRatioSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (quickRatioData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const currentRatioSummaryData = {
    datasets: currentRatioData.datasets,
  };

  const currentRatioSummaryOptions = {
    aspectRatio: 2,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        yAlign: "bottom",
        displayColors: false,
        callbacks: {
          label: function(tooltipItem, data, value) {
            if (tooltipItem.dataset.needleValue < 0.6) {
              return `In Good condition`;
            } else if (
              tooltipItem.dataset.needleValue >= 0.6 &&
              tooltipItem.dataset.needleValue < 1
            ) {
              return `In Worrying condition`;
            } else if (tooltipItem.dataset.needleValue >= 1) {
              return `In Bad condition`;
            }
          },
        },
      },
    },
  };

  const currentRatioSummaryPlugins = {
    id: "currentRatioSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (currentRatioData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const debtEquityRatioSummaryData = {
    datasets: debEquityRatio.datasets,
  };

  const debtEquityRatioSummaryOptions = {
    aspectRatio: 2,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        yAlign: "bottom",
        displayColors: false,
        callbacks: {
          label: function(tooltipItem, data, value) {
            if (tooltipItem.dataset.needleValue <= 1) {
              return `In Good condition`;
            } else if (
              tooltipItem.dataset.needleValue > 1 &&
              tooltipItem.dataset.needleValue <= 2
            ) {
              return `In Worrying condition`;
            } else if (tooltipItem.dataset.needleValue > 2) {
              return `In Bad condition`;
            }
          },
        },
      },
    },
  };

  const debtEquityRatioSummaryPlugins = {
    id: "debtEquityRatioSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (debEquityRatio.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const equityRatioSummaryData = {
    datasets: equityRatio.datasets,
  };

  const equityRatioSummaryOptions = {
    aspectRatio: 2,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        yAlign: "bottom",
        displayColors: false,
        callbacks: {
          label: function(tooltipItem, data, value) {
            if (tooltipItem.dataset.needleValue >= 50) {
              return `In Good condition`;
            } else if (
              tooltipItem.dataset.needleValue >= 25 &&
              tooltipItem.dataset.needleValue < 50
            ) {
              return `In Worrying condition`;
            } else if (tooltipItem.dataset.needleValue < 25) {
              return `In Bad condition`;
            }
          },
        },
      },
    },
  };

  const equityRatioSummaryPlugins = {
    id: "equityRatioSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (equityRatio.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const netProfitMarginSummaryData = {
    datasets: netProfitMargin.datasets,
  };

  const netProfitMarginSummaryOptions = {
    aspectRatio: 2,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        yAlign: "bottom",
        displayColors: false,
        callbacks: {
          label: function(tooltipItem, data, value) {
            if (tooltipItem.dataset.needleValue >= 20) {
              return `In Good condition`;
            } else if (
              tooltipItem.dataset.needleValue >= 10 &&
              tooltipItem.dataset.needleValue < 20
            ) {
              return `In Worrying condition`;
            } else if (tooltipItem.dataset.needleValue < 10) {
              return `In Bad condition`;
            }
          },
        },
      },
    },
  };

  const netProfitMarginSummaryPlugins = {
    id: "netProfitMarginSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (netProfitMargin.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const grossProfitMarginSummaryData = {
    datasets: grossProfitMargin.datasets,
  };

  const grossProfitMarginSummaryOptions = {
    aspectRatio: 2,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        yAlign: "bottom",
        displayColors: false,
        callbacks: {
          label: function(tooltipItem, data, value) {
            if (tooltipItem.dataset.needleValue >= 70) {
              return `In Good condition`;
            } else if (
              tooltipItem.dataset.needleValue >= 50 &&
              tooltipItem.dataset.needleValue < 70
            ) {
              return `In Worrying condition`;
            } else if (tooltipItem.dataset.needleValue < 50) {
              return `In Bad condition`;
            }
          },
        },
      },
    },
  };

  const grossProfitMarginSummaryPlugins = {
    id: "grossProfitMarginSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (grossProfitMargin.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const [profitLossSummaryAmount, setProfitLossSummaryAmount] = useState({
    netProfit: 0,
    grossProfit: 0,
    expenses: 0,
  });
  const [profitLossSummaryData, setProfitLossSummaryData] = useState({
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        type: "line",
        label: "Net Profit",
        borderColor: "#12b18c",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        type: "bar",
        label: "Gross Profit",
        backgroundColor: "#0096ec",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        borderColor: "white",
        borderWidth: 2,
        borderRadius: 10,
      },
      {
        type: "bar",
        label: "Expenses",
        backgroundColor: "#f1416c",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        borderColor: "white",
        borderWidth: 2,
        borderRadius: 10,
      },
    ],
  });

  const profitLossSummaryOptions = {
    maintainAspectRatio: false,
    aspectRatio: 1,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.dataset.label}: ${companyProfile.currency.currencyCode} ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#6c7293",
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
    },
  };

  const invoiceStatusSummaryData = {
    labels: ["Paid", "Outstanding", "Overdue"],
    datasets: receivablesInvoiceStatus.datasets,
  };

  const invoiceStatusSummaryOptions = {
    aspectRatio: 2,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "right",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.label}: ${companyProfile.currency.currencyCode} ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
  };

  const invoiceStatusSummaryPlugins = {
    id: "invoiceStatusSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (receivablesInvoiceStatus.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const incomingInvoiceStatusSummaryData = {
    labels: ["Paid", "Outstanding", "Overdue"],
    datasets: payableInvoiceStatus.datasets,
  };

  const incomingInvoiceStatusSummaryOptions = {
    aspectRatio: 2,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "right",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.label}: ${companyProfile.currency.currencyCode} ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
  };

  const incomingInvoiceStatusSummaryPlugins = {
    id: "incomingInvoiceStatusSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (payableInvoiceStatus.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const invoiceAgingSummaryData = {
    labels: ["A/R Invoice Aging"],
    datasets: receivablesAgingSummary.datasets,
  };

  const invoiceAgingSummaryOptions = {
    indexAxis: "y",
    maintainAspectRatio: false,
    aspectRatio: 3.5,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "top",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.dataset.label}: ${companyProfile.currency.currencyCode} ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        stacked: true,
        ticks: {
          color: "#6c7293",
          display: false,
        },
        grid: {
          color: "#ebedef",
          display: false,
        },
      },
    },
  };

  const incomingInvoiceAgingSummaryData = {
    labels: ["A/P Invoice Aging"],
    datasets: payableAgingSummary.datasets,
  };

  const incomingInvoiceAgingSummaryOptions = {
    indexAxis: "y",
    maintainAspectRatio: false,
    aspectRatio: 3.5,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "top",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.dataset.label}: ${companyProfile.currency.currencyCode} ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        stacked: true,
        ticks: {
          color: "#6c7293",
          display: false,
        },
        grid: {
          color: "#ebedef",
          display: false,
        },
      },
    },
  };

  const [cashFlowSummaryData, setCashFlowSummaryData] = useState({
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        type: "line",
        label: "Ending Cash on Hand",
        borderColor: "#12b18c",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        type: "bar",
        label: "Cash In",
        backgroundColor: "#0096ec",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        borderColor: "white",
        borderWidth: 2,
        borderRadius: 10,
      },
      {
        type: "bar",
        label: "Cash Out",
        backgroundColor: "#f1416c",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        borderColor: "white",
        borderWidth: 2,
        borderRadius: 10,
      },
    ],
  });

  const cashFlowSummaryOptions = {
    maintainAspectRatio: false,
    aspectRatio: 2.2,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.dataset.label}: ${companyProfile.currency.currencyCode} ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#6c7293",
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
    },
  };

  const [
    turnoverAPARRatioSummaryData,
    setTurnoverAPARRatioSummaryData,
  ] = useState({
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        type: "bar",
        label: "Accounts Receivable Turnover",
        backgroundColor: "#0096ec",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        borderColor: "white",
        borderWidth: 2,
        borderRadius: 10,
      },
      {
        type: "bar",
        label: "Accounts Payable Turnover",
        backgroundColor: "#f1416c",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        borderColor: "white",
        borderWidth: 2,
        borderRadius: 10,
      },
    ],
  });

  const turnoverAPARRatioSummaryOptions = {
    maintainAspectRatio: false,
    aspectRatio: 2.2,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.dataset.label}: ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#6c7293",
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
    },
  };

  const [workingCapitalSummaryData, setWorkingCapitalSummaryData] = useState({
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        type: "line",
        label: "Net Working Capital",
        borderColor: "#12b18c",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        type: "line",
        label: "Gross Working Capital",
        borderColor: "#0096ec",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
  });

  const workingCapitalSummaryOptions = {
    maintainAspectRatio: false,
    aspectRatio: 2.2,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.dataset.label}: ${companyProfile.currency.currencyCode} ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#6c7293",
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
    },
  };

  const [topRevenuesSummaryData, setTopRevenuesSummaryData] = useState({
    labels: ["", "", "", "", ""],
    datasets: [
      {
        data: [0, 0, 0, 0, 0],
        backgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
        hoverBackgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
      },
    ],
  });

  const topRevenuesSummaryOptions = {
    aspectRatio: 2,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "right",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.label}: ${companyProfile.currency.currencyCode} ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
  };

  const topRevenuesSummaryPlugins = {
    id: "topRevenuesSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (topRevenuesSummaryData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const [topExpensesSummaryData, setTopExpensesSummaryData] = useState({
    labels: ["", "", "", "", ""],
    datasets: [
      {
        data: [0, 0, 0, 0, 0],
        backgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
        hoverBackgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
      },
    ],
  });

  const topExpensesSummaryOptions = {
    aspectRatio: 2,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "right",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.label}: ${companyProfile.currency.currencyCode} ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
  };

  const topExpensesSummaryPlugins = {
    id: "topExpensesSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (topExpensesSummaryData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  async function getFinanceDashboardData() {
    const response = await getFinanceDashboard(fiscalYear, fiscalPeriod);
    const { data } = response.data;
    const {
      quickRatio,
      datasetsQuickRatio,
      currentRatio,
      datasetsCurrentRatio,
      debtEquityRatio,
      datasetsDebtEquityRatio,
      equityRatio,
      datasetsEquityRatio,
      netProfitMargin,
      datasetsNetProfitMargin,
      grossProfitMargin,
      datasetsGrossProfitMargin,
      cashAmountHeader,
      inventoryAmountHeader,
      receivablesAmountHeader,
      payablesAmountHeader,
      netProfitHeader,
      revenuesHeader,
      cogsHeader,
      expensesHeader,
      datasetsReceivableInvoiceStatus,
      receivablePaid,
      receivableOutstanding,
      receivableOverdue,
      datasetsPayableInvoiceStatus,
      payablePaid,
      payableOutstanding,
      payableOverdue,
      datasetsAccountsReceivableAging,
      receivableTotal,
      receivableCurrent,
      receivableThirtyDay,
      receivableSixtyDay,
      receivableNinetyDay,
      receivableOverNinetyDay,
      datasetsAccountsPayableAging,
      payableTotal,
      payableCurrent,
      payableThirtyDay,
      payableSixtyDay,
      payableNinetyDay,
      payableOverNinetyDay,
      profitLossSummary,
      cashFlow,
      turnoverAPARRatioSummary,
      workingCapitalSummary,
      topRevenuesSummary,
      topExpensesSummary,
    } = data;
    setQuickRatioData({
      datasets: datasetsQuickRatio,
      quickRatio: quickRatio,
    });
    setCurrentRatioData({
      datasets: datasetsCurrentRatio,
      currentRatio: currentRatio,
    });
    setDebEquityRatio({
      datasets: datasetsDebtEquityRatio,
      debtEquityRatio: debtEquityRatio,
    });
    setEquityRatio({
      datasets: datasetsEquityRatio,
      equityRatio: equityRatio,
    });
    setNetProfitMargin({
      datasets: datasetsNetProfitMargin,
      netProfitMargin: netProfitMargin,
    });
    setGrossProfitMargin({
      datasets: datasetsGrossProfitMargin,
      grossProfitMargin: grossProfitMargin,
    });
    setTotalCashAmount(cashAmountHeader.totalCashAmount);
    setTotalCashAmountPercent(cashAmountHeader.totalCashAmountPercent);
    setTotalInventoryAmount(inventoryAmountHeader.totalInventoryAmount);
    setTotalInventoryAmountPercent(
      inventoryAmountHeader.totalInventoryAmountPercent
    );
    setTotalReceivablesAmount(receivablesAmountHeader.totalReceivablesAmount);
    setTotalReceivablesAmountPercent(
      receivablesAmountHeader.totalReceivablesAmountPercent
    );
    setTotalPayablesAmount(payablesAmountHeader.totalPayablesAmount);
    setTotalPayablesAmountPercent(
      payablesAmountHeader.totalPayablesAmountPercent
    );
    setTotalNetProfitThisMonth(netProfitHeader.totalNetProfitThisMonth);
    setTotalNetProfitLastMonth(netProfitHeader.totalNetProfitLastMonth);
    setTotalNetProfitPercent(netProfitHeader.totalNetProfitPercent);
    setTotalRevenuesThisMonth(revenuesHeader.totalRevenuesThisMonth);
    setTotalRevenuesLastMonth(revenuesHeader.totalRevenuesLastMonth);
    setTotalRevenuesPercent(revenuesHeader.totalRevenuesPercent);
    setTotalCOGSThisMonth(cogsHeader.totalCOGSThisMonth);
    setTotalCOGSLastMonth(cogsHeader.totalCOGSLastMonth);
    setTotalCOGSPercent(cogsHeader.totalCOGSPercent);
    setTotalExpensesThisMonth(expensesHeader.totalExpensesThisMonth);
    setTotalExpensesLastMonth(expensesHeader.totalExpensesLastMonth);
    setTotalExpensesPercent(expensesHeader.totalExpensesPercent);
    setReceivablesInvoiceStatus({
      datasets: datasetsReceivableInvoiceStatus,
      receivablePaid: receivablePaid,
      receivableOutstanding: receivableOutstanding,
      receivableOverdue: receivableOverdue,
    });
    setPayablesInvoiceStatus({
      datasets: datasetsPayableInvoiceStatus,
      payablePaid: payablePaid,
      payableOutstanding: payableOutstanding,
      payableOverdue: payableOverdue,
    });
    setReceivablesAgingSummary({
      datasets: datasetsAccountsReceivableAging,
      receivableTotal: receivableTotal,
      receivableCurrent: receivableCurrent,
      receivableThirtyDay: receivableThirtyDay,
      receivableSixtyDay: receivableSixtyDay,
      receivableNinetyDay: receivableNinetyDay,
      receivableOverNinetyDay: receivableOverNinetyDay,
    });
    setPayableAgingSummary({
      datasets: datasetsAccountsPayableAging,
      payableTotal: payableTotal,
      payableCurrent: payableCurrent,
      payableThirtyDay: payableThirtyDay,
      payableSixtyDay: payableSixtyDay,
      payableNinetyDay: payableNinetyDay,
      payableOverNinetyDay: payableOverNinetyDay,
    });
    setProfitLossSummaryData(profitLossSummary.dataset);
    setProfitLossSummaryAmount({
      netProfit: profitLossSummary.netProfit,
      grossProfit: profitLossSummary.grossProfit,
      expenses: profitLossSummary.expenses,
    });
    setCashFlowSummaryData(cashFlow);
    setTurnoverAPARRatioSummaryData(turnoverAPARRatioSummary.datasets);
    setWorkingCapitalSummaryData(workingCapitalSummary.datasets);
    setTopRevenuesSummaryData(topRevenuesSummary.datasets);
    setTopExpensesSummaryData(topExpensesSummary.datasets);
  }

  async function getProfitLossSummaryData(fiscalYearID = 0) {
    const response = await getProfitLossSummary(fiscalYearID);
    const { data } = response.data;
    setProfitLossSummaryData(data.profitLossSummary);
    setProfitLossSummaryAmount({
      netProfit: data.netProfit,
      grossProfit: data.grossProfit,
      expenses: data.expenses,
    });
  }

  async function getCashFlowSummaryData(fiscalYearID = 0) {
    const response = await getCashFlowReport(fiscalYearID, 0, 0);
    const { data } = response.data;
    setCashFlowSummaryData(data.cashFlow);
  }

  async function getTurnoverAPARRatioSummaryData(fiscalYearID = 0) {
    const response = await getTurnoverAPARRatioSummary(fiscalYearID);
    const { data } = response.data;
    setTurnoverAPARRatioSummaryData(data.turnoverAPARRatioSummary);
  }

  async function getWorkingCapitalSummaryData(fiscalYearID = 0) {
    const response = await getWorkingCapitalSummary(fiscalYearID);
    const { data } = response.data;
    setWorkingCapitalSummaryData(data.workingCapitalSummary);
  }

  async function getTopRevenuesSummaryData(fiscalPeriodID = 0) {
    const response = await getTopRevenuesSummary(fiscalPeriodID);
    const { data } = response.data;
    setTopRevenuesSummaryData(data.topRevenuesSummary);
  }

  async function getTopExpensesSummaryData(fiscalPeriodID = 0) {
    const response = await getTopExpensesSummary(fiscalPeriodID);
    const { data } = response.data;
    setTopExpensesSummaryData(data.topExpensesSummary);
  }

  useEffect(() => {
    getFinanceDashboardData();
  }, [reload]);

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-2 col-md-2 col-lg-2 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="doughnut"
                  data={quickRatioSummaryData}
                  options={quickRatioSummaryOptions}
                  plugins={[quickRatioSummaryPlugins]}
                  style={{ minHeight: "60px" }}
                />
                <div className="row justify-content-center mt-n4">
                  <div className="col-sm-8 col-md-8 col-lg-8 px-0">
                    <Typography
                      variant="h5"
                      className="kt-font-bolder text-center mt-n1"
                    >
                      {ratioFormat(quickRatioData.quickRatio, 2)}
                    </Typography>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12 px-0">
                    <Typography className="kt-font-bold text-muted text-center mt-n1">
                      Quick Ratio
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-2 col-md-2 col-lg-2 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="doughnut"
                  data={currentRatioSummaryData}
                  options={currentRatioSummaryOptions}
                  plugins={[currentRatioSummaryPlugins]}
                  style={{ minHeight: "60px" }}
                />
                <div className="row justify-content-center mt-n4">
                  <div className="col-sm-8 col-md-8 col-lg-8 px-0">
                    <Typography
                      variant="h5"
                      className="kt-font-bolder text-center mt-n1"
                    >
                      {ratioFormat(currentRatioData.currentRatio, 2)}
                    </Typography>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12 px-0">
                    <Typography className="kt-font-bold text-muted text-center mt-n1">
                      Current Ratio
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-2 col-md-2 col-lg-2 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="doughnut"
                  data={debtEquityRatioSummaryData}
                  options={debtEquityRatioSummaryOptions}
                  plugins={[debtEquityRatioSummaryPlugins]}
                  style={{ minHeight: "60px" }}
                />
                <div className="row justify-content-center mt-n4">
                  <div className="col-sm-8 col-md-8 col-lg-8 px-0">
                    <Typography
                      variant="h5"
                      className="kt-font-bolder text-center mt-n1"
                    >
                      {ratioFormat(debEquityRatio.debtEquityRatio, 2)}
                    </Typography>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12 px-0">
                    <Typography className="kt-font-bold text-muted text-center mt-n1">
                      Debt Equity Ratio
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-2 col-md-2 col-lg-2 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="doughnut"
                  data={equityRatioSummaryData}
                  options={equityRatioSummaryOptions}
                  plugins={[equityRatioSummaryPlugins]}
                  style={{ minHeight: "60px" }}
                />
                <div className="row justify-content-center mt-n4">
                  <div className="col-sm-8 col-md-8 col-lg-8 px-0">
                    <Typography
                      variant="h5"
                      className="kt-font-bolder text-center mt-n1"
                    >
                      {formatPercent(equityRatio.equityRatio, 2)}
                    </Typography>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12 px-0">
                    <Typography className="kt-font-bold text-muted text-center mt-n1">
                      Equity Ratio
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-2 col-md-2 col-lg-2 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="doughnut"
                  data={netProfitMarginSummaryData}
                  options={netProfitMarginSummaryOptions}
                  plugins={[netProfitMarginSummaryPlugins]}
                  style={{ minHeight: "60px" }}
                />
                <div className="row justify-content-center mt-n4">
                  <div className="col-sm-8 col-md-8 col-lg-8 px-0">
                    <Typography
                      variant="h5"
                      className="kt-font-bolder text-center mt-n1"
                    >
                      {formatPercent(netProfitMargin.netProfitMargin, 2)}
                    </Typography>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12 px-0">
                    <Typography className="kt-font-bold text-muted text-center mt-n1">
                      Net Profit Margin
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-2 col-md-2 col-lg-2 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="doughnut"
                  data={grossProfitMarginSummaryData}
                  options={grossProfitMarginSummaryOptions}
                  plugins={[grossProfitMarginSummaryPlugins]}
                  style={{ minHeight: "60px" }}
                />
                <div className="row justify-content-center mt-n4">
                  <div className="col-sm-8 col-md-8 col-lg-8 px-0">
                    <Typography
                      variant="h5"
                      className="kt-font-bolder text-center mt-n1"
                    >
                      {formatPercent(grossProfitMargin.grossProfitMargin, 2)}
                    </Typography>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12 px-0">
                    <Typography className="kt-font-bold text-muted text-center mt-n1">
                      Gross Profit Margin
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-3 col-md-3 col-lg-3 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="kt-widget4">
              <div className="kt-widget4__item">
                <span className="kt-widget4__icon kt-widget4__icon--2x">
                  <i className="fas fa-money-bill-wave" />
                </span>
                <div className="kt-widget4__info pr-0">
                  <div className="kt-widget4__title pr-0">
                    <Typography className="kt-font-bold text-muted">
                      Cash on Hand
                    </Typography>
                  </div>
                  <div className="kt-widget4__value">
                    <Typography variant="h6" className="kt-font-bolder">
                      {companyProfile.currency.currencyCode}{" "}
                      {abbrNum(totalCashAmount, 2)}
                    </Typography>
                  </div>
                  <div className="kt-widget4__forecast">
                    {totalCashAmountPercent === 0 ? (
                      <Typography className="kt-font-bold text-info">
                        <i className="fas fa-angle-double-right kt-font-info"></i>{" "}
                        {formatPercent(totalCashAmountPercent, 2, true)}
                      </Typography>
                    ) : totalCashAmountPercent > 0 ? (
                      <Typography className="kt-font-bold text-success">
                        <i className="fas fa-angle-double-up kt-font-success"></i>{" "}
                        {formatPercent(totalCashAmountPercent, 2, true)}
                      </Typography>
                    ) : totalCashAmountPercent < 0 ? (
                      <Typography className="kt-font-bold text-danger">
                        <i className="fas fa-angle-double-down kt-font-danger"></i>{" "}
                        {formatPercent(totalCashAmountPercent, 2, true)}
                      </Typography>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="kt-widget4">
              <div className="kt-widget4__item">
                <span className="kt-widget4__icon kt-widget4__icon--2x">
                  <i className="fas fa-box-open" />
                </span>
                <div className="kt-widget4__info pr-0">
                  <div className="kt-widget4__title pr-0">
                    <Typography className="kt-font-bold text-muted">
                      Inventory
                    </Typography>
                  </div>
                  <div className="kt-widget4__value">
                    <Typography variant="h6" className="kt-font-bolder">
                      {companyProfile.currency.currencyCode}{" "}
                      {abbrNum(totalInventoryAmount, 2)}
                    </Typography>
                  </div>
                  <div className="kt-widget4__forecast">
                    {totalInventoryAmountPercent === 0 ? (
                      <Typography className="kt-font-bold text-info">
                        <i className="fas fa-angle-double-right kt-font-info"></i>{" "}
                        {formatPercent(totalInventoryAmountPercent, 2, true)}
                      </Typography>
                    ) : totalInventoryAmountPercent > 0 ? (
                      <Typography className="kt-font-bold text-success">
                        <i className="fas fa-angle-double-up kt-font-success"></i>{" "}
                        {formatPercent(totalInventoryAmountPercent, 2, true)}
                      </Typography>
                    ) : totalInventoryAmountPercent < 0 ? (
                      <Typography className="kt-font-bold text-danger">
                        <i className="fas fa-angle-double-down kt-font-danger"></i>{" "}
                        {formatPercent(totalInventoryAmountPercent, 2, true)}
                      </Typography>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="kt-widget4">
              <div className="kt-widget4__item">
                <span className="kt-widget4__icon kt-widget4__icon--2x">
                  <i className="fas fa-file-invoice-dollar" />
                </span>
                <div className="kt-widget4__info pr-0">
                  <div className="kt-widget4__title pr-0">
                    <Typography className="kt-font-bold text-muted">
                      Accounts Receivable
                    </Typography>
                  </div>
                  <div className="kt-widget4__value">
                    <Typography variant="h6" className="kt-font-bolder">
                      {companyProfile.currency.currencyCode}{" "}
                      {abbrNum(totalReceivablesAmount, 2)}
                    </Typography>
                  </div>
                  <div className="kt-widget4__forecast">
                    {totalReceivablesAmountPercent === 0 ? (
                      <Typography className="kt-font-bold text-info">
                        <i className="fas fa-angle-double-right kt-font-info"></i>{" "}
                        {formatPercent(totalReceivablesAmountPercent, 2, true)}
                      </Typography>
                    ) : totalReceivablesAmountPercent > 0 ? (
                      <Typography className="kt-font-bold text-success">
                        <i className="fas fa-angle-double-up kt-font-success"></i>{" "}
                        {formatPercent(totalReceivablesAmountPercent, 2, true)}
                      </Typography>
                    ) : totalReceivablesAmountPercent < 0 ? (
                      <Typography className="kt-font-bold text-danger">
                        <i className="fas fa-angle-double-down kt-font-danger"></i>{" "}
                        {formatPercent(totalReceivablesAmountPercent, 2, true)}
                      </Typography>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-3 col-md-3 col-lg-3 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="kt-widget4">
              <div className="kt-widget4__item">
                <span className="kt-widget4__icon kt-widget4__icon--2x">
                  <i className="fas fa-file-invoice" />
                </span>
                <div className="kt-widget4__info pr-0">
                  <div className="kt-widget4__title pr-0">
                    <Typography className="kt-font-bold text-muted">
                      Accounts Payable
                    </Typography>
                  </div>
                  <div className="kt-widget4__value">
                    <Typography variant="h6" className="kt-font-bolder">
                      {companyProfile.currency.currencyCode}{" "}
                      {abbrNum(totalPayablesAmount, 2)}
                    </Typography>
                  </div>
                  <div className="kt-widget4__forecast">
                    {totalPayablesAmountPercent === 0 ? (
                      <Typography className="kt-font-bold text-info">
                        <i className="fas fa-angle-double-right kt-font-info"></i>{" "}
                        {formatPercent(totalPayablesAmountPercent, 2, true)}
                      </Typography>
                    ) : totalPayablesAmountPercent > 0 ? (
                      <Typography className="kt-font-bold text-success">
                        <i className="fas fa-angle-double-up kt-font-success"></i>{" "}
                        {formatPercent(totalPayablesAmountPercent, 2, true)}
                      </Typography>
                    ) : totalPayablesAmountPercent < 0 ? (
                      <Typography className="kt-font-bold text-danger">
                        <i className="fas fa-angle-double-down kt-font-danger"></i>{" "}
                        {formatPercent(totalPayablesAmountPercent, 2, true)}
                      </Typography>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6 col-md-6 col-lg-6 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Profit & Loss Summary
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(fiscalYearProfitLoss.startMonthName) +
                            " " +
                            fiscalYearProfitLoss.year +
                            " - " +
                            abbrMonthName(fiscalYearProfitLoss.endMonthName) +
                            " " +
                            fiscalYearProfitLoss.yearTo}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalYearProfitLoss(true);
                              setOpenSearchFiscalYear(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-9 col-lg-9">
                <Chart
                  type="bar"
                  data={profitLossSummaryData}
                  options={profitLossSummaryOptions}
                  style={{ minHeight: "250px" }}
                />
              </div>
              <div className="col-sm-12 col-md-3 col-lg-3 p-0">
                <div className="column">
                  <div className="col-sm-12 col-md-12 col-lg-12 pl-md-0">
                    <div className="row mt-4">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bold text-muted text-center text-md-left">
                          Total Net Profit
                        </Typography>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bolder text-center text-md-left">
                          {companyProfile.currency.currencyCode}{" "}
                          {abbrNum(profitLossSummaryAmount.netProfit, 2)}
                        </Typography>
                      </div>
                    </div>
                    <div className="row mt-4">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bold text-muted text-center text-md-left">
                          Total Gross Profit
                        </Typography>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bolder text-center text-md-left">
                          {companyProfile.currency.currencyCode}{" "}
                          {abbrNum(profitLossSummaryAmount.grossProfit, 2)}
                        </Typography>
                      </div>
                    </div>
                    <div className="row mt-4">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bold text-muted text-center text-md-left">
                          Total Expenses
                        </Typography>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bolder text-center text-md-left">
                          {companyProfile.currency.currencyCode}{" "}
                          {abbrNum(profitLossSummaryAmount.expenses, 2)}
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-6">
          <div className="row">
            <div className="col-sm-6 col-md-6 col-lg-6 mb-3">
              <div className="card h-100 px-3 py-3">
                <div className="row mb-3">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bolder text-center text-md-left py-1">
                      A/R Invoice Status
                    </Typography>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Chart
                      type="doughnut"
                      data={invoiceStatusSummaryData}
                      options={invoiceStatusSummaryOptions}
                      plugins={[invoiceStatusSummaryPlugins]}
                      style={{ minHeight: "123px" }}
                    />
                    <div className="column mt-4 mb-3">
                      <div className="col-sm-12 col-md-12 col-lg-12 px-0">
                        <Card
                          id="overviewdashboardcard"
                          className="border-success"
                        >
                          <div className="kt-widget4">
                            <div className="kt-widget4__item">
                              <div className="kt-widget4__info">
                                <Typography className="kt-font-bold text-muted">
                                  Paid
                                </Typography>
                              </div>
                              <Typography className="kt-font-bolder text-right">
                                {companyProfile.currency.currencyCode}{" "}
                                {abbrNum(
                                  receivablesInvoiceStatus.receivablePaid,
                                  2
                                )}
                              </Typography>
                            </div>
                          </div>
                        </Card>
                      </div>
                      <div className="col-sm-12 col-md-12 col-lg-12 px-0">
                        <Card
                          id="overviewdashboardcard"
                          className="border-warning"
                        >
                          <div className="kt-widget4">
                            <div className="kt-widget4__item">
                              <div className="kt-widget4__info">
                                <Typography className="kt-font-bold text-muted">
                                  Outstanding
                                </Typography>
                              </div>
                              <Typography className="kt-font-bolder text-right">
                                {companyProfile.currency.currencyCode}{" "}
                                {abbrNum(
                                  receivablesInvoiceStatus.receivableOutstanding,
                                  2
                                )}
                              </Typography>
                            </div>
                          </div>
                        </Card>
                      </div>
                      <div className="col-sm-12 col-md-12 col-lg-12 px-0">
                        <Card
                          id="overviewdashboardcard"
                          className="border-danger"
                        >
                          <div className="kt-widget4">
                            <div className="kt-widget4__item">
                              <div className="kt-widget4__info">
                                <Typography className="kt-font-bold text-muted">
                                  Overdue
                                </Typography>
                              </div>
                              <Typography className="kt-font-bolder text-right">
                                {companyProfile.currency.currencyCode}{" "}
                                {abbrNum(
                                  receivablesInvoiceStatus.receivableOverdue,
                                  2
                                )}
                              </Typography>
                            </div>
                          </div>
                        </Card>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-md-6 col-lg-6 mb-3">
              <div className="card h-100 px-3 py-3">
                <div className="row mb-3">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bolder text-center text-md-left py-1">
                      A/P Invoice Status
                    </Typography>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Chart
                      type="doughnut"
                      data={incomingInvoiceStatusSummaryData}
                      options={incomingInvoiceStatusSummaryOptions}
                      plugins={[incomingInvoiceStatusSummaryPlugins]}
                      style={{ minHeight: "123px" }}
                    />
                    <div className="column mt-4 mb-3">
                      <div className="col-sm-12 col-md-12 col-lg-12 px-0">
                        <Card
                          id="overviewdashboardcard"
                          className="border-success"
                        >
                          <div className="kt-widget4">
                            <div className="kt-widget4__item">
                              <div className="kt-widget4__info">
                                <Typography className="kt-font-bold text-muted">
                                  Paid
                                </Typography>
                              </div>
                              <Typography className="kt-font-bolder text-right">
                                {companyProfile.currency.currencyCode}{" "}
                                {abbrNum(payableInvoiceStatus.payablePaid, 2)}
                              </Typography>
                            </div>
                          </div>
                        </Card>
                      </div>
                      <div className="col-sm-12 col-md-12 col-lg-12 px-0">
                        <Card
                          id="overviewdashboardcard"
                          className="border-warning"
                        >
                          <div className="kt-widget4">
                            <div className="kt-widget4__item">
                              <div className="kt-widget4__info">
                                <Typography className="kt-font-bold text-muted">
                                  Outstanding
                                </Typography>
                              </div>
                              <Typography className="kt-font-bolder text-right">
                                {companyProfile.currency.currencyCode}{" "}
                                {abbrNum(
                                  payableInvoiceStatus.payableOutstanding,
                                  2
                                )}
                              </Typography>
                            </div>
                          </div>
                        </Card>
                      </div>
                      <div className="col-sm-12 col-md-12 col-lg-12 px-0">
                        <Card
                          id="overviewdashboardcard"
                          className="border-danger"
                        >
                          <div className="kt-widget4">
                            <div className="kt-widget4__item">
                              <div className="kt-widget4__info">
                                <Typography className="kt-font-bold text-muted">
                                  Overdue
                                </Typography>
                              </div>
                              <Typography className="kt-font-bolder text-right">
                                {companyProfile.currency.currencyCode}{" "}
                                {abbrNum(
                                  payableInvoiceStatus.payableOverdue,
                                  2
                                )}
                              </Typography>
                            </div>
                          </div>
                        </Card>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-3 col-md-3 col-lg-3">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 mb-3">
              <div className="card h-100 px-3 py-3">
                <Table borderless size="xl" responsive="xl">
                  <tbody>
                    <tr>
                      <td colSpan="2" className="px-0 py-0">
                        {totalNetProfitPercent === 0 ? (
                          <Typography
                            variant="h5"
                            className="kt-font-bolder text-center text-info"
                          >
                            <i className="fas fa-angle-double-right kt-font-info"></i>{" "}
                            {formatPercent(totalNetProfitPercent, 2, true)}
                          </Typography>
                        ) : totalNetProfitPercent > 0 ? (
                          <Typography
                            variant="h5"
                            className="kt-font-bolder text-center text-success"
                          >
                            <i className="fas fa-angle-double-up kt-font-success"></i>{" "}
                            {formatPercent(totalNetProfitPercent, 2, true)}
                          </Typography>
                        ) : totalNetProfitPercent < 0 ? (
                          <Typography
                            variant="h5"
                            className="kt-font-bolder text-center text-danger"
                          >
                            <i className="fas fa-angle-double-down kt-font-danger"></i>{" "}
                            {formatPercent(totalNetProfitPercent, 2, true)}
                          </Typography>
                        ) : null}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2" className="px-0 pt-0 pb-2">
                        <Typography
                          variant="subtitle2"
                          className="kt-font-bold text-center text-muted"
                        >
                          Net Profit
                        </Typography>
                      </td>
                    </tr>
                    <tr>
                      <td className="pl-0 py-0 border-right">
                        <Typography className="kt-font-bolder text-right">
                          {companyProfile.currency.currencyCode}{" "}
                          {abbrNum(totalNetProfitThisMonth, 2)}
                        </Typography>
                      </td>
                      <td className="pr-0 py-0">
                        <Typography className="kt-font-bolder">
                          {companyProfile.currency.currencyCode}{" "}
                          {abbrNum(totalNetProfitLastMonth, 2)}
                        </Typography>
                      </td>
                    </tr>
                    <tr>
                      <td className="pl-0 py-0 border-right">
                        <Typography
                          variant="subtitle2"
                          className="kt-font-bold text-right text-muted"
                        >
                          This Month
                        </Typography>
                      </td>
                      <td className="pr-0 py-0">
                        <Typography
                          variant="subtitle2"
                          className="kt-font-bold text-muted"
                        >
                          Last Month
                        </Typography>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 mb-3">
              <div className="card h-100 px-3 py-3">
                <Table borderless size="xl" responsive="xl">
                  <tbody>
                    <tr>
                      <td colSpan="2" className="px-0 py-0">
                        {totalRevenuesPercent === 0 ? (
                          <Typography
                            variant="h5"
                            className="kt-font-bolder text-center text-info"
                          >
                            <i className="fas fa-angle-double-right kt-font-info"></i>{" "}
                            {formatPercent(totalRevenuesPercent, 2, true)}
                          </Typography>
                        ) : totalRevenuesPercent > 0 ? (
                          <Typography
                            variant="h5"
                            className="kt-font-bolder text-center text-success"
                          >
                            <i className="fas fa-angle-double-up kt-font-success"></i>{" "}
                            {formatPercent(totalRevenuesPercent, 2, true)}
                          </Typography>
                        ) : totalRevenuesPercent < 0 ? (
                          <Typography
                            variant="h5"
                            className="kt-font-bolder text-center text-danger"
                          >
                            <i className="fas fa-angle-double-down kt-font-danger"></i>{" "}
                            {formatPercent(totalRevenuesPercent, 2, true)}
                          </Typography>
                        ) : null}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2" className="px-0 pt-0 pb-2">
                        <Typography
                          variant="subtitle2"
                          className="kt-font-bold text-center text-muted"
                        >
                          Revenue
                        </Typography>
                      </td>
                    </tr>
                    <tr>
                      <td className="pl-0 py-0 border-right">
                        <Typography className="kt-font-bolder text-right">
                          {companyProfile.currency.currencyCode}{" "}
                          {abbrNum(totalRevenuesThisMonth, 2)}
                        </Typography>
                      </td>
                      <td className="pr-0 py-0">
                        <Typography className="kt-font-bolder">
                          {companyProfile.currency.currencyCode}{" "}
                          {abbrNum(totalRevenuesLastMonth, 2)}
                        </Typography>
                      </td>
                    </tr>
                    <tr>
                      <td className="pl-0 py-0 border-right">
                        <Typography
                          variant="subtitle2"
                          className="kt-font-bold text-right text-muted"
                        >
                          This Month
                        </Typography>
                      </td>
                      <td className="pr-0 py-0">
                        <Typography
                          variant="subtitle2"
                          className="kt-font-bold text-muted"
                        >
                          Last Month
                        </Typography>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 mb-3">
              <div className="card h-100 px-3 py-3">
                <Table borderless size="xl" responsive="xl">
                  <tbody>
                    <tr>
                      <td colSpan="2" className="px-0 py-0">
                        {totalCOGSPercent === 0 ? (
                          <Typography
                            variant="h5"
                            className="kt-font-bolder text-center text-info"
                          >
                            <i className="fas fa-angle-double-right kt-font-info"></i>{" "}
                            {formatPercent(totalCOGSPercent, 2, true)}
                          </Typography>
                        ) : totalCOGSPercent > 0 ? (
                          <Typography
                            variant="h5"
                            className="kt-font-bolder text-center text-success"
                          >
                            <i className="fas fa-angle-double-up kt-font-success"></i>{" "}
                            {formatPercent(totalCOGSPercent, 2, true)}
                          </Typography>
                        ) : totalCOGSPercent < 0 ? (
                          <Typography
                            variant="h5"
                            className="kt-font-bolder text-center text-danger"
                          >
                            <i className="fas fa-angle-double-down kt-font-danger"></i>{" "}
                            {formatPercent(totalCOGSPercent, 2, true)}
                          </Typography>
                        ) : null}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2" className="px-0 pt-0 pb-2">
                        <Typography
                          variant="subtitle2"
                          className="kt-font-bold text-center text-muted"
                        >
                          Cost of Goods Sold
                        </Typography>
                      </td>
                    </tr>
                    <tr>
                      <td className="pl-0 py-0 border-right">
                        <Typography className="kt-font-bolder text-right">
                          {companyProfile.currency.currencyCode}{" "}
                          {abbrNum(totalCOGSThisMonth, 2)}
                        </Typography>
                      </td>
                      <td className="pr-0 py-0">
                        <Typography className="kt-font-bolder">
                          {companyProfile.currency.currencyCode}{" "}
                          {abbrNum(totalCOGSLastMonth, 2)}
                        </Typography>
                      </td>
                    </tr>
                    <tr>
                      <td className="pl-0 py-0 border-right">
                        <Typography
                          variant="subtitle2"
                          className="kt-font-bold text-right text-muted"
                        >
                          This Month
                        </Typography>
                      </td>
                      <td className="pr-0 py-0">
                        <Typography
                          variant="subtitle2"
                          className="kt-font-bold text-muted"
                        >
                          Last Month
                        </Typography>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 mb-3">
              <div className="card h-100 px-3 py-3">
                <Table borderless size="xl" responsive="xl">
                  <tbody>
                    <tr>
                      <td colSpan="2" className="px-0 py-0">
                        {totalExpensesPercent === 0 ? (
                          <Typography
                            variant="h5"
                            className="kt-font-bolder text-center text-info"
                          >
                            <i className="fas fa-angle-double-right kt-font-info"></i>{" "}
                            {formatPercent(totalExpensesPercent, 2, true)}
                          </Typography>
                        ) : totalExpensesPercent > 0 ? (
                          <Typography
                            variant="h5"
                            className="kt-font-bolder text-center text-success"
                          >
                            <i className="fas fa-angle-double-up kt-font-success"></i>{" "}
                            {formatPercent(totalExpensesPercent, 2, true)}
                          </Typography>
                        ) : totalExpensesPercent < 0 ? (
                          <Typography
                            variant="h5"
                            className="kt-font-bolder text-center text-danger"
                          >
                            <i className="fas fa-angle-double-down kt-font-danger"></i>{" "}
                            {formatPercent(totalExpensesPercent, 2, true)}
                          </Typography>
                        ) : null}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2" className="px-0 pt-0 pb-2">
                        <Typography
                          variant="subtitle2"
                          className="kt-font-bold text-center text-muted"
                        >
                          Expenses
                        </Typography>
                      </td>
                    </tr>
                    <tr>
                      <td className="pl-0 py-0 border-right">
                        <Typography className="kt-font-bolder text-right">
                          {companyProfile.currency.currencyCode}{" "}
                          {abbrNum(totalExpensesThisMonth, 2)}
                        </Typography>
                      </td>
                      <td className="pr-0 py-0">
                        <Typography className="kt-font-bolder">
                          {companyProfile.currency.currencyCode}{" "}
                          {abbrNum(totalExpensesLastMonth, 2)}
                        </Typography>
                      </td>
                    </tr>
                    <tr>
                      <td className="pl-0 py-0 border-right">
                        <Typography
                          variant="subtitle2"
                          className="kt-font-bold text-right text-muted"
                        >
                          This Month
                        </Typography>
                      </td>
                      <td className="pr-0 py-0">
                        <Typography
                          variant="subtitle2"
                          className="kt-font-bold text-muted"
                        >
                          Last Month
                        </Typography>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-9 col-md-9 col-lg-9">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 mb-3">
              <div className="card h-100 px-3 py-3">
                <div className="row mb-3">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bolder text-center text-md-left py-1">
                      A/R Invoice Aging Summary
                    </Typography>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography
                      variant="body2"
                      className="text-muted text-center text-md-left px-3"
                    >
                      Total Receivables: {companyProfile.currency.currencyCode}{" "}
                      {abbrNum(receivablesAgingSummary.receivableTotal, 2)}
                    </Typography>
                    <Chart
                      type="bar"
                      data={invoiceAgingSummaryData}
                      options={invoiceAgingSummaryOptions}
                      style={{ minHeight: "86px" }}
                    />
                    <div className="row justify-content-center py-2 px-0 py-md-2 px-md-5">
                      <div className="col-sm-12 col-md-12 col-lg-12 px-0 px-md-5">
                        <div className="d-flex justify-content-between">
                          <div className="column">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                              <div className="row mt-2">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <Typography className="kt-font-bold text-muted text-left">
                                    Current
                                  </Typography>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <Typography className="kt-font-bolder text-left">
                                    {companyProfile.currency.currencyCode}{" "}
                                    {abbrNum(
                                      receivablesAgingSummary.receivableCurrent,
                                      2
                                    )}
                                  </Typography>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="column">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                              <div className="row mt-2">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <Typography className="kt-font-bold text-muted text-left">
                                    Overdue{" "}
                                    <i className="fas fa-arrow-circle-right kt-font-danger"></i>
                                  </Typography>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <Typography className="kt-font-bolder text-left">
                                    {companyProfile.currency.currencyCode}{" "}
                                    {abbrNum(
                                      receivablesAgingSummary.receivableThirtyDay,
                                      2
                                    )}
                                  </Typography>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <Typography
                                    variant="subtitle2"
                                    className="text-muted text-left"
                                  >
                                    1 - 30 days
                                  </Typography>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="column">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                              <div className="row mt-2">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <br />
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <Typography className="kt-font-bolder text-left">
                                    {companyProfile.currency.currencyCode}{" "}
                                    {abbrNum(
                                      receivablesAgingSummary.receivableSixtyDay,
                                      2
                                    )}
                                  </Typography>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <Typography
                                    variant="subtitle2"
                                    className="text-muted text-left"
                                  >
                                    31 - 60 days
                                  </Typography>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="column">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                              <div className="row mt-2">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <br />
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <Typography className="kt-font-bolder text-left">
                                    {companyProfile.currency.currencyCode}{" "}
                                    {abbrNum(
                                      receivablesAgingSummary.receivableNinetyDay,
                                      2
                                    )}
                                  </Typography>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <Typography
                                    variant="subtitle2"
                                    className="text-muted text-left"
                                  >
                                    61 - 90 days
                                  </Typography>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="column">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                              <div className="row mt-2">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <br />
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <Typography className="kt-font-bolder text-left">
                                    {companyProfile.currency.currencyCode}{" "}
                                    {abbrNum(
                                      receivablesAgingSummary.receivableOverNinetyDay,
                                      2
                                    )}
                                  </Typography>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <Typography
                                    variant="subtitle2"
                                    className="text-muted text-left"
                                  >
                                    Above 90 days
                                  </Typography>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12 mb-3">
              <div className="card h-100 px-3 py-3">
                <div className="row mb-3">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bolder text-center text-md-left py-1">
                      A/P Invoice Aging Summary
                    </Typography>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography
                      variant="body2"
                      className="text-muted text-center text-md-left px-3"
                    >
                      Total Payables: {companyProfile.currency.currencyCode}{" "}
                      {abbrNum(payableAgingSummary.payableTotal, 2)}
                    </Typography>
                    <Chart
                      type="bar"
                      data={incomingInvoiceAgingSummaryData}
                      options={incomingInvoiceAgingSummaryOptions}
                      style={{ minHeight: "86px" }}
                    />
                    <div className="row justify-content-center py-2 px-0 py-md-2 px-md-5">
                      <div className="col-sm-12 col-md-12 col-lg-12 px-0 px-md-5">
                        <div className="d-flex justify-content-between">
                          <div className="column">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                              <div className="row mt-2">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <Typography className="kt-font-bold text-muted text-left">
                                    Current
                                  </Typography>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <Typography className="kt-font-bolder text-left">
                                    {companyProfile.currency.currencyCode}{" "}
                                    {abbrNum(
                                      payableAgingSummary.payableCurrent,
                                      2
                                    )}
                                  </Typography>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="column">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                              <div className="row mt-2">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <Typography className="kt-font-bold text-muted text-left">
                                    Overdue{" "}
                                    <i className="fas fa-arrow-circle-right kt-font-danger"></i>
                                  </Typography>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <Typography className="kt-font-bolder text-left">
                                    {companyProfile.currency.currencyCode}{" "}
                                    {abbrNum(
                                      payableAgingSummary.payableThirtyDay,
                                      2
                                    )}
                                  </Typography>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <Typography
                                    variant="subtitle2"
                                    className="text-muted text-left"
                                  >
                                    1 - 30 days
                                  </Typography>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="column">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                              <div className="row mt-2">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <br />
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <Typography className="kt-font-bolder text-left">
                                    {companyProfile.currency.currencyCode}{" "}
                                    {abbrNum(
                                      payableAgingSummary.payableSixtyDay,
                                      2
                                    )}
                                  </Typography>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <Typography
                                    variant="subtitle2"
                                    className="text-muted text-left"
                                  >
                                    31 - 60 days
                                  </Typography>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="column">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                              <div className="row mt-2">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <br />
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <Typography className="kt-font-bolder text-left">
                                    {companyProfile.currency.currencyCode}{" "}
                                    {abbrNum(
                                      payableAgingSummary.payableNinetyDay,
                                      2
                                    )}
                                  </Typography>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <Typography
                                    variant="subtitle2"
                                    className="text-muted text-left"
                                  >
                                    61 - 90 days
                                  </Typography>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="column">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                              <div className="row mt-2">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <br />
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <Typography className="kt-font-bolder text-left">
                                    {companyProfile.currency.currencyCode}{" "}
                                    {abbrNum(
                                      payableAgingSummary.payableOverNinetyDay,
                                      2
                                    )}
                                  </Typography>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <Typography
                                    variant="subtitle2"
                                    className="text-muted text-left"
                                  >
                                    Above 90 days
                                  </Typography>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6 col-md-6 col-lg-6 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Cash Flow
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(fiscalYearCashFlow.startMonthName) +
                            " " +
                            fiscalYearCashFlow.year +
                            " - " +
                            abbrMonthName(fiscalYearCashFlow.endMonthName) +
                            " " +
                            fiscalYearCashFlow.yearTo}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalYearCashFlow(true);
                              setOpenSearchFiscalYear(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="bar"
                  data={cashFlowSummaryData}
                  options={cashFlowSummaryOptions}
                  style={{ minHeight: "180px" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-6 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  A/R vs A/P Turnover Ratio
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(
                            fiscalYearTurnoverAPARRatio.startMonthName
                          ) +
                            " " +
                            fiscalYearTurnoverAPARRatio.year +
                            " - " +
                            abbrMonthName(
                              fiscalYearTurnoverAPARRatio.endMonthName
                            ) +
                            " " +
                            fiscalYearTurnoverAPARRatio.yearTo}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalYearTurnoverAPARRatio(true);
                              setOpenSearchFiscalYear(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="bar"
                  data={turnoverAPARRatioSummaryData}
                  options={turnoverAPARRatioSummaryOptions}
                  style={{ minHeight: "180px" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6 col-md-6 col-lg-6 mb-3">
          <div className="card h-100 px-3 py-3">
            <div className="row mb-3">
              <div className="col-sm-12 col-md-6 col-lg-6">
                <Typography className="kt-font-bolder text-center text-md-left py-1">
                  Working Capital
                </Typography>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="row mr-2">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Typography className="kt-font-bold text-muted text-center text-md-right">
                      <span>
                        <span className="mr-1">
                          {abbrMonthName(
                            fiscalYearWorkingCapital.startMonthName
                          ) +
                            " " +
                            fiscalYearWorkingCapital.year +
                            " - " +
                            abbrMonthName(
                              fiscalYearWorkingCapital.endMonthName
                            ) +
                            " " +
                            fiscalYearWorkingCapital.yearTo}
                        </span>
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalYearWorkingCapital(true);
                              setOpenSearchFiscalYear(true);
                            }}
                            edge="end"
                            className="px-1 py-1"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Chart
                  type="bar"
                  data={workingCapitalSummaryData}
                  options={workingCapitalSummaryOptions}
                  style={{ minHeight: "180px" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-6">
          <div className="row">
            <div className="col-sm-6 col-md-6 col-lg-6 mb-3">
              <div className="card h-100 px-3 py-3">
                <div className="row mb-3">
                  <div className="col-sm-12 col-md-5 col-lg-5">
                    <Typography className="kt-font-bolder text-center text-md-left py-1">
                      Top 5 Revenues
                    </Typography>
                  </div>
                  <div className="col-sm-12 col-md-7 col-lg-7">
                    <div className="row mr-2">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bold text-muted text-center text-md-right">
                          <span>
                            <span className="mr-1">
                              {abbrMonthName(
                                fiscalPeriodTopRevenues.monthName
                              ) +
                                " " +
                                fiscalPeriodTopRevenues.year}
                            </span>
                            <BootstrapTooltip title="Search">
                              <IconButton
                                type="button"
                                aria-label="Search"
                                onClick={() => {
                                  setOpenSearchFiscalPeriodTopRevenues(true);
                                  setOpenSearchFiscalPeriod(true);
                                }}
                                edge="end"
                                className="px-1 py-1"
                              >
                                <Search />
                              </IconButton>
                            </BootstrapTooltip>
                          </span>
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Chart
                      type="doughnut"
                      data={topRevenuesSummaryData}
                      options={topRevenuesSummaryOptions}
                      plugins={[topRevenuesSummaryPlugins]}
                      style={{ minHeight: "162px" }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-md-6 col-lg-6 mb-3">
              <div className="card h-100 px-3 py-3">
                <div className="row mb-3">
                  <div className="col-sm-12 col-md-5 col-lg-5">
                    <Typography className="kt-font-bolder text-center text-md-left py-1">
                      Top 5 Expenses
                    </Typography>
                  </div>
                  <div className="col-sm-12 col-md-7 col-lg-7">
                    <div className="row mr-2">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <Typography className="kt-font-bold text-muted text-center text-md-right">
                          <span>
                            <span className="mr-1">
                              {abbrMonthName(
                                fiscalPeriodTopExpenses.monthName
                              ) +
                                " " +
                                fiscalPeriodTopExpenses.year}
                            </span>
                            <BootstrapTooltip title="Search">
                              <IconButton
                                type="button"
                                aria-label="Search"
                                onClick={() => {
                                  setOpenSearchFiscalPeriodTopExpenses(true);
                                  setOpenSearchFiscalPeriod(true);
                                }}
                                edge="end"
                                className="px-1 py-1"
                              >
                                <Search />
                              </IconButton>
                            </BootstrapTooltip>
                          </span>
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <Chart
                      type="doughnut"
                      data={topExpensesSummaryData}
                      options={topExpensesSummaryOptions}
                      plugins={[topExpensesSummaryPlugins]}
                      style={{ minHeight: "162px" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DialogLayout
        open={openSearchFiscalYear}
        title="Search Fiscal Year"
        onCloseDialog={() => {
          setOpenSearchFiscalYear(false);
        }}
        maxWIdth="md"
      >
        <SearchFiscalYear
          onSelectFiscalYear={(fiscalYear) => {
            if (openSearchFiscalYearProfitLoss) {
              setFiscalYearProfitLoss({
                ID: fiscalYear.ID,
                year: fiscalYear.year,
                yearTo: fiscalYear.yearTo,
                startMonth: fiscalYear.startMonth,
                startMonthName: fiscalYear.startMonthName,
                endMonth: fiscalYear.endMonth,
                endMonthName: fiscalYear.endMonthName,
              });
              setOpenSearchFiscalYearProfitLoss(false);
              getProfitLossSummaryData(fiscalYear.ID);
            } else if (openSearchFiscalYearCashFlow) {
              setFiscalYearCashFlow({
                ID: fiscalYear.ID,
                year: fiscalYear.year,
                yearTo: fiscalYear.yearTo,
                startMonth: fiscalYear.startMonth,
                startMonthName: fiscalYear.startMonthName,
                endMonth: fiscalYear.endMonth,
                endMonthName: fiscalYear.endMonthName,
              });
              setOpenSearchFiscalYearCashFlow(false);
              getCashFlowSummaryData(fiscalYear.ID);
            } else if (openSearchFiscalYearTurnoverAPARRatio) {
              setFiscalYearTurnoverAPARRatio({
                ID: fiscalYear.ID,
                year: fiscalYear.year,
                yearTo: fiscalYear.yearTo,
                startMonth: fiscalYear.startMonth,
                startMonthName: fiscalYear.startMonthName,
                endMonth: fiscalYear.endMonth,
                endMonthName: fiscalYear.endMonthName,
              });
              setOpenSearchFiscalYearTurnoverAPARRatio(false);
              getTurnoverAPARRatioSummaryData(fiscalYear.ID);
            } else if (openSearchFiscalYearWorkingCapital) {
              setFiscalYearWorkingCapital({
                ID: fiscalYear.ID,
                year: fiscalYear.year,
                yearTo: fiscalYear.yearTo,
                startMonth: fiscalYear.startMonth,
                startMonthName: fiscalYear.startMonthName,
                endMonth: fiscalYear.endMonth,
                endMonthName: fiscalYear.endMonthName,
              });
              setOpenSearchFiscalYearWorkingCapital(false);
              getWorkingCapitalSummaryData(fiscalYear.ID);
            }
            setOpenSearchFiscalYear(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchFiscalYear(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchFiscalPeriod}
        title="Search Fiscal Period"
        onCloseDialog={() => {
          setOpenSearchFiscalPeriod(false);
        }}
        maxWIdth="md"
      >
        <SearchFiscalPeriod
          onSelectFiscalPeriod={(fiscalPeriod) => {
            if (openSearchFiscalPeriodTopRevenues) {
              setFiscalPeriodTopRevenues({
                ID: fiscalPeriod.ID,
                fiscalYearID: fiscalPeriod.fiscalYearID,
                year: fiscalPeriod.year,
                month: fiscalPeriod.month,
                monthName: fiscalPeriod.monthName,
                statusID: fiscalPeriod.statusID,
              });
              setOpenSearchFiscalPeriodTopRevenues(false);
              getTopRevenuesSummaryData(fiscalPeriod.ID);
            } else if (openSearchFiscalPeriodTopExpenses) {
              setFiscalPeriodTopExpenses({
                ID: fiscalPeriod.ID,
                fiscalYearID: fiscalPeriod.fiscalYearID,
                year: fiscalPeriod.year,
                month: fiscalPeriod.month,
                monthName: fiscalPeriod.monthName,
                statusID: fiscalPeriod.statusID,
              });
              setOpenSearchFiscalPeriodTopExpenses(false);
              getTopExpensesSummaryData(fiscalPeriod.ID);
            }
            setOpenSearchFiscalPeriod(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchFiscalPeriod(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
}

export default FinanceDashboard;
